import { render, staticRenderFns } from "./Generic.vue?vue&type=template&id=a9655536&scoped=true&"
import script from "./Generic.vue?vue&type=script&lang=js&"
export * from "./Generic.vue?vue&type=script&lang=js&"
import style2 from "./Generic.vue?vue&type=style&index=2&id=a9655536&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9655536",
  null
  
)

export default component.exports